// extracted by mini-css-extract-plugin
export default {"wrapper":"cards_wrapper__V8bCf"};